import { Box, Container, Typography, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import ExternalLinks from "../ExternalLink/ExternalLinks";
import { APP_PATH, instituteInfo } from "../../constant";

const linkStyle = { textDecoration: "none", color: "white" };

const Footer = () => {
  return (
    <Box
      sx={{ backgroundColor: "#333", py: 4, color: "white", marginTop: "50px" }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center" textAlign="center">
          <Grid item xs={12}>
            <Typography variant="h6">Institut {instituteInfo.name}</Typography>
            <Typography variant="body2">
              Téléphone : {instituteInfo.number}
            </Typography>
            <Typography variant="body2">
              Email : {instituteInfo.gmail}
            </Typography>
          </Grid>

          {/* Liens rapides */}
          <Grid item xs={12}>
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="center"
              mt={2}
            >
              <Box m={1}>
                <Link to={APP_PATH.PROGRAM} style={linkStyle}>
                  <Typography variant="body2">Programme</Typography>
                </Link>
              </Box>
              <Box m={1}>
                <Link to={APP_PATH.PRICING} style={linkStyle}>
                  <Typography variant="body2">Tarifs</Typography>
                </Link>
              </Box>
              <Box m={1}>
                <Link to={APP_PATH.RULES} style={linkStyle}>
                  <Typography variant="body2">Règlement</Typography>
                </Link>
              </Box>
              <Box m={1}>
                <Link to={APP_PATH.ABOUT} style={linkStyle}>
                  <Typography variant="body2">A propos de</Typography>
                </Link>
              </Box>
              <Box m={1}>
                <Link to={APP_PATH.CONTACT} style={linkStyle}>
                  <Typography variant="body2">Nous contacter</Typography>
                </Link>
              </Box>
              <Box m={1}>
                <Link to={APP_PATH.SUBSCRIBE} style={linkStyle}>
                  <Typography variant="body2">Inscription</Typography>
                </Link>
              </Box>
            </Box>
          </Grid>

          {/* Réseaux sociaux */}
          <Grid item xs={12}>
            <ExternalLinks />
          </Grid>
        </Grid>
      </Container>
      <Typography variant="body1" align="center" sx={{ mt: 4 }}>
        &copy; {new Date().getFullYear()} Institut Al-Ansarr. Tous droits
        réservés.
      </Typography>
    </Box>
  );
};

export default Footer;
